import { useEffect, useState } from "react";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

import { abbrNum } from "$utils/number-helper";
import { LabelCurrencyTooltip } from "../tooltips/currency";
import { GRID_STROKE } from "../svg-definitions";
import { capitalizeFirstLetter } from "$utils/text-helpers";
import { getTerm } from "$stores/dictionary";

const StackedBarChart = ({ data, selectedIndex, onSelect, keysToLabel, yDomain = [(dataMin) => 0, (dataMax) => Math.floor(dataMax * 1.5)] }) => {
    const [focusBarIndex, setFocusBarIndex] = useState(-1);

    useEffect(() => {
        if ((selectedIndex || selectedIndex === 0) && selectedIndex != focusBarIndex) {
            setFocusBarIndex(selectedIndex);
        } else if (selectedIndex === "") {
            setFocusBarIndex(-1);
        }
    }, [selectedIndex]);

    const handleSelect = (state) => {
        if (data.length <= 1) {
            return;
        }
        const newSelected = !state || isNaN(state.activeTooltipIndex) || state.activeTooltipIndex === focusBarIndex ? -1 : state.activeTooltipIndex;

        setFocusBarIndex(newSelected);
        if (onSelect) {
            onSelect(newSelected);
        }
    };

    return (
        <ResponsiveContainer width="99%">
            <BarChart data={data} stackOffset="sign" onClick={handleSelect} margin={{ top: 20, right: 30, left: 20, bottom: 5 }} barSize={15} barGap={50}>
                <XAxis dataKey="name" angle={45} height={140} textAnchor="start" interval={0} padding={{ right: 50 }} />
                <YAxis tickFormatter={(label) => `$${abbrNum(label)}`} />
                <CartesianGrid stroke={GRID_STROKE} strokeDasharray="3 3" />
                <Tooltip cursor={{ fill: "rgba(28, 54, 66, 0.8)" }} content={LabelCurrencyTooltip} keysToLabel={keysToLabel} />
                <Legend formatter={(value, entry, index) => entry?.payload?.label || capitalizeFirstLetter(value)} />
                <Bar label={getTerm("growthPotential")} dataKey="growth" stackId="a" fill="#18b2dc">
                    {data.map((entry, index) => (
                        <Cell key={`growth_${index}`} fill={focusBarIndex < 0 || focusBarIndex === index ? "#18b2dc" : "rgba(24, 178, 220, 0.3)"} />
                    ))}
                </Bar>

                <Bar label={getTerm("revenueAtRisk")} dataKey="revenueAtRisk" stackId="a" fill="#fd9332">
                    {data.map((entry, index) => (
                        <Cell key={`churn_${index}`} fill={focusBarIndex < 0 || focusBarIndex === index ? "#fd9332" : "rgba(253, 147, 50, 0.3"} />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default StackedBarChart;
